import React, { useMemo } from 'react';

import { useAppSelector } from '../../../../hooks/react-redux';
import { useFetchStarted } from '../../../../hooks/useFetchStarted';
import { fetchAllDropdownListsStarted } from '../../../admin/dropdown-lists/store';
import { fetchAllNettingEntitiesStarted } from '../../../admin/entity/store';
import { getIsLoading, getIsOpening, fetchNettingEngineDocumentsStarted, NettingEngineTableView, getNettingEngineTableView } from '../store';
import { DocumentType } from '../../../documents/store/types';
import { NettingEngineDocumentsTable } from './NettingEngineDocumentsTable';
import { PageLoadingDots } from '../../../shared/loading-dots/PageLoadingDots';
import { fetchAllDocumentGroupsStarted, fetchAvailableDocumentNamesStarted } from '../../../admin/documents/store';

export const NettingEngineDocuments: React.FC = () => {
    const documentView = useAppSelector(getNettingEngineTableView);
    const isExistingView = useMemo(() => documentView === NettingEngineTableView.EXISTING, [documentView]);

    useFetchStarted([fetchNettingEngineDocumentsStarted(1, isExistingView ? DocumentType.ORIGINAL : DocumentType.PRE_EXECUTION_DRAFT), fetchAllDropdownListsStarted(), fetchAllNettingEntitiesStarted(), fetchAllDocumentGroupsStarted(), fetchAvailableDocumentNamesStarted()]);

    const isLoading = useAppSelector(getIsLoading);
    const isOpening = useAppSelector(getIsOpening);

    const nettingEngineBody = useMemo(() => {
        if (isLoading || isOpening) {
            return <PageLoadingDots />;
        }
        return <NettingEngineDocumentsTable isExistingView={isExistingView} />;
    }, [isLoading, isOpening, isExistingView]);

    return nettingEngineBody;
};
